module.exports = __webpack_public_path__ + "img/envelope-light.c5d603d8.svg";